import React from 'react';
import styles from './CyberGridBackground.module.css';

// ページ全体の縦横グリッド背景（緑・サイバー感）。
export default function CyberGridBackground({ className = '' }) {
  return (
    <div className={`${styles.wrapper} ${className}`} aria-hidden="true">
      <div className={styles.base} />
      <div className={styles.grid} />
    </div>
  );
}
